var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel-item',[_c('v-img',{attrs:{"id":"inspoImgs","src":_vm.imageURL}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }